import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
} from 'react';
import { useFetchNotification } from '../hooks/useFetchNotification';
import { NotificationData } from '../model/NotificationData';

const NotificationContext = createContext<{
  notificationData: NotificationData;
  setNotificationData: Dispatch<SetStateAction<NotificationData>> | null;
}>({ notificationData: {}, setNotificationData: null });

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const { notificationData, setNotificationData } = useFetchNotification();
  return (
    <NotificationContext.Provider
      value={{ notificationData, setNotificationData }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const { notificationData, setNotificationData } =
    useContext(NotificationContext);
  if (!setNotificationData) {
    throw Error('Notification data is not in the context');
  }
  return { notificationData, setNotificationData };
};
